var map = {
	"./asset-hyperlink.json": 42789,
	"./blockquote.json": 1795,
	"./document.json": 51253,
	"./embedded-asset-block.json": 94743,
	"./embedded-entry-block.json": 30675,
	"./embedded-entry-inline.json": 73857,
	"./embedded-resource-block.json": 15667,
	"./embedded-resource-inline.json": 43361,
	"./entry-hyperlink.json": 91501,
	"./heading-1.json": 93618,
	"./heading-2.json": 32771,
	"./heading-3.json": 76828,
	"./heading-4.json": 58357,
	"./heading-5.json": 20630,
	"./heading-6.json": 30599,
	"./hr.json": 51054,
	"./hyperlink.json": 86704,
	"./list-item.json": 43298,
	"./ordered-list.json": 56672,
	"./paragraph.json": 15652,
	"./resource-hyperlink.json": 56895,
	"./table-cell.json": 11987,
	"./table-header-cell.json": 23099,
	"./table-row.json": 65063,
	"./table.json": 48254,
	"./text.json": 86035,
	"./unordered-list.json": 60219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11820;